import React, { useEffect, useState } from "react";
import { Alert, Input, Label, FormFeedback, Button, Spinner } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser, resetRegisterFlag } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

//import images 
import ParticlesAuth from "./ParticlesAuth";
import { createSelector } from "reselect";

const PASSWORD_REQUIREMENT_MESSAGE = "Mật khẩu phải có ít nhất 8 ký tự, gồm chữ hoa, chữ thường, số và ký tự đặc biệt";
const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

const Register = () => {
    const [loader, setLoader] = useState<boolean>(false);
    const history = useNavigate();
    const dispatch : any = useDispatch();

    const validation : any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
            first_name: '',
            password: '',
            password_confirmation: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Email không hợp lệ").required("Vui lòng nhập email"),
            first_name: Yup.string().required("Vui lòng nhập họ và tên"),
            password: Yup.string()
                .required("Vui lòng nhập mật khẩu")
                .matches(STRONG_PASSWORD_REGEX, PASSWORD_REQUIREMENT_MESSAGE),
            password_confirmation: Yup.string()
                .oneOf([Yup.ref("password")], "Xác nhận mật khẩu không khớp")
                .required("Vui lòng xác nhận mật khẩu"),
        }),
        onSubmit: (values) => {
            dispatch(registerUser(values));
            setLoader(true)
        }
    });

    const selectLayoutState = (state : any) => state.Account;
    const registerdatatype = createSelector(
        selectLayoutState,
        (account) => ({
            success: account.success,
            error: account.error,
            registrationError: account.registrationError
        })
    );
    // Inside your component
    const {
        error, success, registrationError
    } = useSelector(registerdatatype);

    useEffect(() => {
        // dispatch(apiError(""));
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            history("/create-shop");
        }

        setTimeout(() => {
            dispatch(resetRegisterFlag());
        }, 3000);

    }, [dispatch, success, error, history]);

    useEffect(() => {
        if (error || success) {
            setLoader(false);
        }
    }, [error, success]);

    document.title = "Hệ thống quản lý đặt món - Đăng ký";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-10 col-lg-8">
                            <div className="text-center">
                                <h2 className="text-white">Tạo tài khoản mới</h2>
                                <p className="text-white-50">Nhập thông tin để bắt đầu sử dụng hệ thống.</p>
                            </div>
                            <div className="register-form mt-4">
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}
                                >
                                    {error && (<Alert color="danger">{registrationError || "Đăng ký không thành công. Vui lòng thử lại."}</Alert>)}
                                    {success && (<Alert color="success">Đăng ký thành công! Vui lòng xác minh email để tiếp tục.</Alert>)}
                                    <div className="form-group text-start mb-4">
                                        <span>Họ và tên</span>
                                        <Label>
                                            <i className="mdi mdi-account-outline"></i>
                                        </Label>
                                        <Input
                                            name="first_name"
                                            className="form-control"
                                            placeholder="Nguyễn Văn A"
                                            type="text"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.first_name || ""}
                                            invalid={validation.touched.first_name && validation.errors.first_name ? true : false}
                                        />
                                        {validation.touched.first_name && validation.errors.first_name ? (
                                            <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                                        ) : null}
                                    </div>
                                    <div className="form-group text-start mb-4">
                                        <span>Địa chỉ Email</span>
                                        <Label>
                                            <i className="mdi mdi-email-outline"></i>
                                        </Label>
                                        <Input
                                            name="email"
                                            className="form-control"
                                            placeholder="email@example.com"
                                            type="email"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.email || ""}
                                            invalid={validation.touched.email && validation.errors.email ? true : false}
                                        />
                                        {validation.touched.email && validation.errors.email ? (
                                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                        ) : null}
                                    </div>
                                    <div className="form-group text-start mb-4">
                                        <span>Mật khẩu</span>
                                        <Label>
                                            <i className="mdi mdi-lock-outline"></i>
                                        </Label>
                                        <Input
                                            name="password"
                                            className="form-control"
                                            placeholder="Abc@1234"
                                            type="password"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.password || ""}
                                            invalid={validation.touched.password && validation.errors.password ? true : false}
                                        />
                                        {validation.touched.password && validation.errors.password ? (
                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                        ) : (
                                            <div className="form-text text-white-50">{PASSWORD_REQUIREMENT_MESSAGE}.</div>
                                        )}
                                    </div>
                                    <div className="form-group text-start mb-4">
                                        <span>Xác nhận mật khẩu</span>
                                        <Label>
                                            <i className="mdi mdi-lock-check-outline"></i>
                                        </Label>
                                        <Input
                                            name="password_confirmation"
                                            className="form-control"
                                            placeholder="********"
                                            type="password"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.password_confirmation || ""}
                                            invalid={validation.touched.password_confirmation && validation.errors.password_confirmation ? true : false}
                                        />
                                        {validation.touched.password_confirmation && validation.errors.password_confirmation ? (
                                            <FormFeedback type="invalid">{validation.errors.password_confirmation}</FormFeedback>
                                        ) : null}
                                    </div>
                                    <Button
                                        className="btn btn-warning btn-lg w-100"
                                        disabled={loader}
                                        type="submit"
                                    >
                                        {loader && <Spinner size="sm" className='me-2'></Spinner>}
                                        Đăng ký
                                    </Button>
                                </form>
                            </div>
                            <div className="login-meta-data">
                                <p className="mb-0 text-white">
                                    Đã có tài khoản? <Link to="/login" className="text-warning">Đăng nhập</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default Register;
